/** 
 * Scripts/Css specific to Company Profile pages
 * Including /success-stories, /news and /videos archives
 * 
 */
import '../Core/scripts/sitewide.js';
import './companyProfile.scss';
import '../Core/scss/_footer.scss';
import '../Core/scss/_enquiryForm.scss';


/**
 * Import Shortlist Functionality
 */
import '../Core/scripts/shortlist';


/**
 * Import needed utilities, like updating catfish forms with the URL of the page
 * 
 */
import {checkCatfishLocation, lazyLoadFooter } from '../Core/scripts/utilities';
import 'owl.carousel/dist/assets/owl.carousel.css';
window.checkCatfishLocation = checkCatfishLocation;

/**
 * Page specific functions
 * 
 */

//Defer loading sidebar until after page load
window.lazyLoadSidebar = function lazyLoadSidebar(entryID) {
    var xhttp = new XMLHttpRequest();
    var sidebar = document.getElementById("sidebar-deferred");
    xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
            // Typical action to be performed when the document is ready:
            sidebar.classList.add('sidebar-fade-out');
            setTimeout(function() {
                sidebar.innerHTML = xhttp.responseText;
                sidebar.classList.remove('sidebar-fade-out');
            }, 1000);
        } else if (this.readyState == 4 && this.status != 200){
            sidebar.innerHTML = "";
        }
    };

    //If the sidebar fails to load, show nothing instead of a constant loading icon
    xhttp.addEventListener("error", sidebarFailed);
    xhttp.addEventListener("abort", sidebarFailed);

    xhttp.open("GET", "/franchise-opportunities/profile_sidebar?id=" + entryID, true);
    xhttp.send();
}

function sidebarFailed() {
    document.getElementById("sidebar-deferred").innerHTML = "";
}

//Defer loading footer until after page load
function footerFailed() {
    document.getElementById("footer-container").innerHTML = "";
}

window.lazyLoadFooter = lazyLoadFooter

document.addEventListener('DOMContentLoaded', function() {
    import(/* webpackPreload: true */ 'owl.carousel')
    .then( module => {
        let owl = $('.promo-carousel__lower');
        owl.owlCarousel({
            dots: false,
            margin: 20,
            loop: true,
            lazyLoad: true,
            navText: [
                '<i class="fa fa-chevron-left" onClick="carouselNavPressed()" aria-hidden="true"></i>',
                '<i class="fa fa-chevron-right" onClick="carouselNavPressed()" aria-hidden="true"></i>'
            ],
            responsive: {
                0: {
                    items: 1,
                    nav: false
                },
                320: {
                    items: 1.2,
                    nav: false
                },
                370: {
                    items: 1.4,
                    nav: false
                },
                505: {
                    items: 1.8,
                    nav: false
                },
                768: {
                    items: 2.4,
                    nav: true
                },
                992: {
                    items: 3,
                    nav: true
                },
                1200: {
                    items: 4,
                    nav: true
                }
            }
        });
    })
})


window.carouselNavPressed = function carouselNavPressed() {
    dataLayer.push({'event': 'myTrackEvent', 'eventCategory': 'Promotions', 'eventAction': 'Carousel', 'eventLabel': 'Nav Button Click'});
}